// Directorio de clientes (API `directorio-clientes`, ver DirectorioClientesController).
import axios from "axios";

export function listarClientes({ filtro = "todos", q = "", page = 1, perPage = 25 } = {}) {
  return axios
    .get("/directorio-clientes", { params: { filtro, q: q || undefined, page, per_page: perPage } })
    .then((r) => r.data);
}

export function buscarClientes(q) {
  return axios.get("/directorio-clientes/buscar", { params: { q } }).then((r) => r.data?.data || []);
}

export function fichaCliente(id) {
  return axios.get(`/directorio-clientes/${id}`).then((r) => r.data);
}

export function datosParaRellenar(id) {
  return axios.get(`/directorio-clientes/${id}/rellenar`).then((r) => r.data?.cliente || null);
}

/** ¿Ya tenemos a esta persona? (documento; nombre completo + nacimiento; teléfono/email + nombre) */
export function coincidenciaCliente(params) {
  return axios.get("/directorio-clientes/coincidencia", { params }).then((r) => r.data?.cliente || null);
}

export function vincularReserva(clienteId, reservaId) {
  return axios.post(`/directorio-clientes/${clienteId}/reservas`, { reserva_id: reservaId }).then((r) => r.data);
}

export function iniciales(c) {
  const n = `${c?.nombre || ""} ${c?.apellido || ""}`.trim();
  if (!n) return "?";
  const partes = n.split(/\s+/);
  return ((partes[0] || "")[0] + ((partes[1] || "")[0] || "")).toUpperCase();
}
